import { React, useEffect, useContext } from "react";
import { Link } from 'react-router-dom';
import { UserContext } from "../contexts/UserContext";
import UserContextProvider from "../contexts/UserContext";
import { userService } from "../services/UserService";
import SubscriptionPageForm from "../components/SubscriptionPageForm";
import SuccessfulPayment from "../components/SuccessfulPayment";

const SuccessPage = () => {
 


	return (
		<UserContextProvider>
		<SuccessfulPayment/>
	  </UserContextProvider>
	);
};

export default SuccessPage;

